import { displayMessage } from "../../../../helpers/messages";

const home_workout_grid_columns = [
    {
        field: "id",
        headerName: displayMessage("ID"),
        flex: 0.5,
        minWidth: 60,
    },
    {
        field: "name",
        headerName: displayMessage("WORKOUT_NAME"),
        flex: 2,
        minWidth: 200,
    },
    {
        field: "description",
        headerName: displayMessage("DESCRIPTION"),
        flex: 2,
        minWidth: 200,
        renderCell: (params) => {
            if (!params.value) return "-";
            return params.value.length > 50 ? `${params.value.substring(0, 50)}...` : params.value;
        },
    },
    {
        field: "duration_minutes",
        headerName: displayMessage("DURATION_MINUTES"),
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            if (!params.value) return "-";
            return `${params.value} min`;
        },
    },
    {
        field: "order_index",
        headerName: displayMessage("ORDER_INDEX"),
        flex: 0.5,
        minWidth: 80,
    },
    {
        field: "exercises_count",
        headerName: displayMessage("EXERCISES"),
        flex: 1,
        minWidth: 100,
        valueGetter: (params) => {
            return params.row?.exercises?.length || 0;
        },
    },
];

export default home_workout_grid_columns;


